import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { createAxiosInstance } from "../axiosSettings";
import { logout } from "./authSlice";

const initialState = {
  isLoading: false,
  appointmentList : [],
  appointmentData : null,
  error : null
};


export const APPOINTMENT_LIST = "admin/appointment/booking/list";
export const APPOINTMENT_DETAIL = "admin/appointment/detail";

export const getAppointmentList = createAsyncThunk(
  APPOINTMENT_LIST,
  async (formData, { rejectWithValue }) => {
    const axiosInstance = await createAxiosInstance();
    try {
      const response = await axiosInstance.get(APPOINTMENT_LIST, {
        params : formData
      });
      if (response.data) {
        return response.data;
      } else {
        return rejectWithValue(response.data.message || "Error");
      }
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message || "Error"
      );
    }
  }
);

export const getAppointmentDetail = createAsyncThunk(
    APPOINTMENT_DETAIL,
    async (id, { rejectWithValue }) => {
      const axiosInstance = await createAxiosInstance();
      try {
        const response = await axiosInstance.get(APPOINTMENT_DETAIL + '/' + id);
        if (response.data) {
          return response.data;
        } else {
          return rejectWithValue(response.data.message || "Error");
        }
      } catch (error) {
        return rejectWithValue(
          error.response?.data?.message || "Error"
        );
      }
    }
);

const appointmentSlice = createSlice({
  name: "appointment",
  initialState,
  extraReducers: (builder) => {
    builder
      .addCase(getAppointmentList.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(getAppointmentList.fulfilled, (state, action) => {
        state.isLoading = false;
        state.appointmentList = action.payload;
      })
      .addCase(getAppointmentList.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload;
      })
      .addCase(getAppointmentDetail.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(getAppointmentDetail.fulfilled, (state, action) => {
        state.isLoading = false;
        state.appointmentData = action.payload;
      })
      .addCase(getAppointmentDetail.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload;
      })
      .addCase(logout, () => initialState);
  },
});

export default appointmentSlice.reducer;